export const classes = (...cls: (string|undefined)[]) => {
  return cls.filter(cls => cls !== undefined).join(' ');
}
